export const getLangFromURL = () => {
  const path = window.location.pathname;
  const match = path.match(/\/compl\/(\w{2})\//);
  return match ? match[1] : 'ru';
};